import { useEffect } from 'react';

/**
 * Reusable Parallax Banner Component
 * Creates a static/fixed background image with parallax scroll effect
 *
 * @param {string} imageUrl - Path to the background image (e.g., '/assets/img/banner1.1.jpg')
 * @param {number} speed - Parallax speed (default: 0.6)
 * @param {number} offset - Parallax offset (default: -100)
 * @param {string} className - Additional CSS classes (optional)
 */
function ParallaxBanner({
  imageUrl,
  speed = 0.6,
  offset = -100,
  className = ''
}) {
  useEffect(() => {
    // Initialize parallax effect
    const initParallax = () => {
      if (window.$ && window.$.fn && window.$.fn.parallaxie) {
        const parallaxBanner = window.$('.parallax-banner-section');

        if (parallaxBanner.length > 0) {
          if (window.$(window).width() < 780) {
            // Mobile: Add class to disable parallax
            parallaxBanner.addClass('paralax-data');
          } else {
            // Desktop: Enable parallax effect
            parallaxBanner.removeClass('paralax-data');
            parallaxBanner.parallaxie({
              speed: speed,
              offset: offset,
            });
          }
        }
      }
    };

    // Initialize after a short delay to ensure jQuery plugins are loaded
    const timer = setTimeout(initParallax, 100);

    return () => {
      clearTimeout(timer);
    };
  }, [speed, offset]);

  return (
    <div
      className={`parallax-banner-section ${className}`}
      style={{ backgroundImage: `url('${imageUrl}')` }}
    >
    </div>
  );
}

export default ParallaxBanner;
